export const lessonTypes = [
  { label: "Listening", value: "LISTEN" },
  { label: "Pronunciation", value: "PRONUNCIATION" },
  { label: "Word Stress", value: "WORD_STRESS" },
  { label: "Conversation", value: "CONVERSATION" },
  { label: "Intonation", value: "SENTENCE_STRESS" },
  { label: "Video Conversation", value: "VIDEO_CONVERSATION" },
  { label: "Unscrambling words", value: "UNSCRAMBLE_WORD" },
  { label: "Missing Characters", value: "MISSING_CHARACTER" },
];

export const gameTypeIcon = {
  PROGRAM_VIDEO: "elsa-game-type-program-video",
  LISTEN: "elsa-game-type-listen",
  CONVERSATION: "elsa-game-type-conversation",
  PRONUNCIATION: "elsa-game-type-pronunciation",
  SENTENCE_STRESS: "elsa-game-type-sentence-stress",
  WORD_STRESS: "elsa-game-type-word-stress",
  PROGRAM_INSIGHT: "elsa-game-type-program-insight",
  VIDEO_CONVERSATION: "elsa-game-type-video-conversation",
  STUDY_SET: "elsa-study-set",
  UNSCRAMBLE_WORD: "elsa-game-type-unscramble-word",
  MISSING_CHARACTER: "elsa-game-type-missing-character",
  AI_TUTOR_STANDALONE: "elsa-ai-lesson",
};

export const getGameTypeIcon = type => gameTypeIcon[type] || "elsa-game-type";
